import { render, staticRenderFns } from "./CekOngkir.vue?vue&type=template&id=2d16a3c9"
import script from "./CekOngkir.vue?vue&type=script&lang=js"
export * from "./CekOngkir.vue?vue&type=script&lang=js"
import style0 from "./CekOngkir.vue?vue&type=style&index=0&id=2d16a3c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports